import React from 'react';
import { connect } from 'react-redux';
import { ContactLink } from 'app/components/ContactLink';
import { ImageSection } from 'app/components/ImageSection';
import { Typography } from '@material-ui/core';
import { withTranslation } from 'react-i18next';
import { FieldNames } from 'app/models/fields/names';
import { LoanPurpose } from 'app/api/rates/types';
import { getFormType } from '../../routes/helpers';
import { FormType } from '@lenderful/domain';

export const NoRatesFoundComponent = ({ ...props }: any) => {
  const {
    pathName,
    stopGateHelocImage,
    stopGateImage,
    t,
    values = {},
  } = props;
  const isHomeEquity = values[FieldNames.loanPurpose] === LoanPurpose.HELOC ||
    getFormType(pathName) === FormType.HOME_EQUITY_TURBO;
  const stopGateMinimumLoanImage = isHomeEquity ? stopGateHelocImage : stopGateImage;
  return (
    <ImageSection image={stopGateMinimumLoanImage}>
      <Typography variant="h6" gutterBottom={true} classes={{ h6: 'contentTitle' }}>
        {t('stopGate.NoRatesFound.title', {
          defaultValue : 'No loan rates were found.',
        })}
      </Typography>
      <Typography variant="body2" gutterBottom={true}>
        {t('stopGate.NoRatesFound.paragraph1', {
          defaultValue:
            'We\'d like to help you with your home equity loan request. One of our loan officers would be happy to assist you.',
        })}
      </Typography>
      <ContactLink
        buttonProps={{
          classes  : { root: 'stackedButton', fullWidth: 'tabletSizeLarge' },
          color    : 'primary',
          fullWidth: true,
          size     : 'large',
          variant  : 'contained',
        }}
      >
        {t('stopGate.NoRatesFound.button.contact', { defaultValue: 'Contact Loan Officer' })}
      </ContactLink>
    </ImageSection>
  );
};

const mapStateToProps = (state: any, ownProps: any) => ({
  NoRatesFound      : state.config.clientMinLoan,
  pathName          : state.router.location.pathname,
  stopGateHelocImage: state.config.stopGateHelocImage,
  stopGateImage     : state.config.stopGateImage,
  ...ownProps,
});

export const NoRatesFound = connect(
  mapStateToProps,
  null,
)(withTranslation()(NoRatesFoundComponent));
